"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.deleteCanSpamSettingEpic = exports.updateCanSpamSettingEpic = exports.createCanSpamSettingEpic = exports.fetchCanSpamSettingsEpic = void 0;

var _reduxObservable = require("redux-observable");

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _map = require("rxjs/operators/map");

var _mergeMap = require("rxjs/operators/mergeMap");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _concat = require("rxjs/observable/concat");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypeFilters"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var fetchCanSpamSettings = function fetchCanSpamSettings() {
  return (0, _fromPromise.fromPromise)(_API.default.getCanSpamSettings()).pipe((0, _map.map)(function (response) {
    return _actions.FetchCanSpamSettings.success(response, {});
  }), (0, _catchError.catchError)(function (error) {
    return (0, _of.of)(_actions.FetchCanSpamSettings.failure(error, {}));
  }), (0, _startWith.startWith)(_actions.FetchCanSpamSettings.request({})));
};

var updateCanSpamSetting = function updateCanSpamSetting(action, getState) {
  var data = action.payload.data;
  return (0, _fromPromise.fromPromise)(_API.default.updateCanSpamSetting(data)).pipe((0, _mergeMap.mergeMap)(function (response) {
    var canSpamSettingId = data.id;
    var requestSettingIsDefault = data.is_default;
    var stateSettingIsDefault = (0, _selectors.getCanSpamSettings)(getState()).get(canSpamSettingId).is_default;
    var success = (0, _of.of)(_actions.UpdateCanSpamSetting.success(response, data));

    if (requestSettingIsDefault && !stateSettingIsDefault) {
      success = (0, _concat.concat)(success, fetchCanSpamSettings());
    }

    return success;
  }), (0, _catchError.catchError)(function (error) {
    return (0, _of.of)(_actions.UpdateCanSpamSetting.failure(error, data));
  }), (0, _startWith.startWith)(_actions.UpdateCanSpamSetting.request(data)));
};

var fetchCanSpamSettingsEpic = function fetchCanSpamSettingsEpic($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.CanSpamSettingsActionTypes.LOAD_CAN_SPAM_SETTINGS).pipe((0, _filter.filter)(function () {
    var status = (0, _selectors.getFetchCanSpamSettingsRequestStatus)(getState());
    return _RequestStatusTypeFilters.default.ALLOW_ONCE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(fetchCanSpamSettings));
};

exports.fetchCanSpamSettingsEpic = fetchCanSpamSettingsEpic;
var createCanSpamSettingEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createCanSpamSetting,
  initiatingActionType: _actions.CanSpamSettingsActionTypes.CREATE_CAN_SPAM_SETTING,
  requestStatusSelector: _selectors.getCreateCanSpamSettingRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.CreateCanSpamSetting
}));
exports.createCanSpamSettingEpic = createCanSpamSettingEpic;

var updateCanSpamSettingEpic = function updateCanSpamSettingEpic($action, _ref2) {
  var getState = _ref2.getState;
  return $action.ofType(_actions.CanSpamSettingsActionTypes.UPDATE_CAN_SPAM_SETTING).pipe((0, _filter.filter)(function () {
    var status = (0, _selectors.getUpdateCanSpamSettingRequestStatus)(getState());
    return _RequestStatusTypeFilters.default.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(function (action) {
    return updateCanSpamSetting(action, getState);
  }));
};

exports.updateCanSpamSettingEpic = updateCanSpamSettingEpic;
var deleteCanSpamSettingEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteCanSpamSetting,
  initiatingActionType: _actions.CanSpamSettingsActionTypes.DELETE_CAN_SPAM_SETTING,
  requestStatusSelector: _selectors.getDeleteCanSpamSettingRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.DeleteCanSpamSetting
}));
exports.deleteCanSpamSettingEpic = deleteCanSpamSettingEpic;

var _default = (0, _reduxObservable.combineEpics)(fetchCanSpamSettingsEpic, createCanSpamSettingEpic, updateCanSpamSettingEpic, deleteCanSpamSettingEpic);

exports.default = _default;